/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Local shell tool definition: Enables the local shell execution tool.
 */
export type LocalShellToolDefinition = {
  type: "local_shell";
};

/** @internal */
export const LocalShellToolDefinition$inboundSchema: z.ZodType<
  LocalShellToolDefinition,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("local_shell"),
});
/** @internal */
export type LocalShellToolDefinition$Outbound = {
  type: "local_shell";
};

/** @internal */
export const LocalShellToolDefinition$outboundSchema: z.ZodType<
  LocalShellToolDefinition$Outbound,
  z.ZodTypeDef,
  LocalShellToolDefinition
> = z.object({
  type: z.literal("local_shell"),
});

export function localShellToolDefinitionToJSON(
  localShellToolDefinition: LocalShellToolDefinition,
): string {
  return JSON.stringify(
    LocalShellToolDefinition$outboundSchema.parse(localShellToolDefinition),
  );
}
export function localShellToolDefinitionFromJSON(
  jsonString: string,
): SafeParseResult<LocalShellToolDefinition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LocalShellToolDefinition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LocalShellToolDefinition' from JSON`,
  );
}
